import VectorService from "@/services/vector.service";
import CustomControl from "./custom-control";
import reportsModule from "@/store/modules/reports.module";
import globalModule from "@/store/modules/global.module";

export default class EraseAllControl extends CustomControl {
    constructor() {
        super(EraseAllControl.buildHtml());
    }

    addEvents(element: HTMLElement): void {
        element.querySelector('button')!.addEventListener('click', () => {
            VectorService.clearVectorSource(6)
            VectorService.clearVectorSource(4)
            VectorService.setViewLayer(5, true)
            reportsModule.report_details.visible = false
            globalModule.setRaster(globalModule.user?.attributes?.preferences?.showRaster)
        }, false)
    }

    static buildHtml() {
        const element = document.createElement('div')
        element.className = 'ol-control erase-control'
        const button = document.createElement('button')
        button.innerHTML = `<img src="${require('@/assets/img/borrar.png')}">`
        element.appendChild(button)
        return element
    }

}